/**
 * Created by dhavaljoshi on 05/02/18.
 */

define(function (require, exports, module) {
  'use strict';

  const REGEX = {
    "PASSWORD": /^(?=.*\d.*\d.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^a-zA-Z0-9\x20])(?=\S+$).{12,}$/,
    "DEVICE_REGEX": /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i,
    "IGNORE_SPACE_REGEX": /\s*,\s*/
  };

  const PUBLISH = {
    "JSON_SEND": "mobile.jsonData.sendData",
    "LOGIN_SUCCESS": "login-loaded-successfully",
    "CXP_ITEM_LOADED": "cxp.item.loaded",
    "BB_ITEM_LOADED": "bb.item.loaded",
    "CLEAR_TOKEN": "mobile.clear.token",
    "LOAD_SUB_PAGE": "mobile.loadSubPage",
    "SIGNOUT": "mobile.signout",
    "PIN_READY": "mobile.login.with.pin.ready",
    "SHOW_PROGRESS": "mobile.show.progress",
    "JSON_UPDATE": "mobile.json.update.data",
    "FILE_INFO": "mobile.fileInformation",
    "LOAD_FROM_STACK": "mobile.loadFromStack",
    "HIDE_PROGRESS": "mobile.hide.progress",
    "TOOLBAR_ENABLE": "mobile.toolbar.enable",
    "TOOLBAR_DISABLE": "mobile.toolbar.disable",
    "REQUEST_PREPARE_TRANSFER": "launchpad-retail.requestPrepareTransfer",
    "TRANSFER_ACTION_RESPONSE": "transfer-action-response",
    "SHOW_MASTER_PROGRESS": "mobile.show.master.progress",
    "HIDE_MASTER_PROGRESS": "mobile.hide.master.progress"
  };

  const SUBSCRIBE = {
    "JSON_DATA": "mobile.json.data",
    "LOGIN_WITH_PIN": "mobile.login.with.pin",
    "SIGNOUT": "mobile.signout.publish",
    "TRANSFER_DETAIL_ID": "transfer-detail-id"
  };

  const COMMON = {
    "CHANGE_PASSWORD": "CHANGE_PASSWORD",
    "ACTIVE": "ACTIVE",
    "XBBXSRF": "X-BBXSRF",
    "X_BBSC": "X_BBSC",
    "XBBXSRFTOKEN": "X-BBXSRFTOKEN",
    "USER_SESSIONID": "userSessionId",
    "LOGIN_WITH_MFA": "LOGIN_WITH_MFA",
    "LOGIN_FIRST_TIME": "LOGIN_FIRST_TIME",
    "TOKEN": "token",
    "COUNTRY": "countryPreferences",
    "PORTAL": "portalName",
    "ACCESS": "accessRights",
    "TEMPLATE": "template",
    "STATUS": "status",
    "FIRST_TIME_USER": "firstTimeUsser",
    "INVALID_PASSWORD": "INVALID_PASSWORD",
    "INVALID_OLD_PASSWORD": "INVALID_OLD_PASSWORD",
    "COOKIE_BBXSRF": "BBXSRF",
    "FORGOT_PASSWORD": "FORGET_PASSWORD",
    "SET_PASSWORD": "SET_PASSWORD",
    "REGISTRATION": "REGISTRATION",
    "DEVICE_NOT_BOUND": "DEVICE_NOT_BOUND",
    "APPROVED": "APPROVED",
    "REJECTED": "REJECTED",
    "EFAWATEERCOM": "EFAWATEERCOM",
    "CREDITCARD": "CREDITCARD",
    "PREPAID": "Prepaid",
    "LOCKED_USER":"LOCKED_USER",
    "CLIENT_NAME": "CLIENT_NAME"
  };

  const PAGE = {
    "MY_BANKING": "MyBanking",
    "TERMS_AND_CONDITIONS": "terms-and-conditions",
    "CHANGE_PASSWORD": "change-password",
    "SIGN_IN": "sign-in",
    "VERIFICATION_CODE": "verificationCode",
    "NEW_PASSWORD": "newPassword",
    "FORGOT_PASSWORD": "forgotPassword",
    "VERIFICATION_METHODS": "mobile.verification",
    "PIN": "mobile.pin",
    "MANAGE_PASSWORD": "mobile.manage.password",
    "PIN_CHANGE": "mobile.pin.change",
    "USER_VERIFICATION": "mobile.user.verification",
    "SAVED_TRANSFER": "mobile.saved.transfer",
    "CONFIRM_PAYMENT": "mobile.confirmPayment",
    "CONFIRM_TRANSFER": "mobile.confirmTransfer"
  };

  const CUSTOM_ERROR_CODES = {
    "UNAUTHORISED": 401,
    "ALREADY_EXISTS": 409,
    "BOUND_ERROR": 451,
    "SERVER_ERROR": 500
  };

  const TAGS = {
    "CC_PAYMENT": "mobile.creditcardpayment",
    "SIGN_IN": "sign-in"
  };

  const MOBILE_SDK_BUTTONS = {
    "POSITIVE": "POSITIVE",
    "NEGATIVE": "NEGATIVE",
    "NEUTRAL": "NEUTRAL"
  }


  Object.freeze(REGEX);
  Object.freeze(PUBLISH);
  Object.freeze(SUBSCRIBE);
  Object.freeze(COMMON);
  Object.freeze(PAGE);
  Object.freeze(CUSTOM_ERROR_CODES);
  Object.freeze(TAGS);
  Object.freeze(MOBILE_SDK_BUTTONS);

  exports.lpConstants = {
    "REGEX": REGEX,
    "PUBLISH": PUBLISH,
    "SUBSCRIBE": SUBSCRIBE,
    "COMMON": COMMON,
    "PAGE": PAGE,
    "CUSTOM_ERROR_CODES": CUSTOM_ERROR_CODES,
    "TAGS": TAGS,
    "MOBILE_SDK_BUTTONS": MOBILE_SDK_BUTTONS
  };

});


//////////////////
// WEBPACK FOOTER
// ./scripts/constants.js
// module id = 10
// module chunks = 0